import { Grid } from '@mui/material'

interface HeaderProps {
  leftNode: React.ReactNode
  rightNode: React.ReactNode
}

function Header({ leftNode, rightNode }: HeaderProps) {
  return (
    <Grid container bgcolor="grey.800" px={2} py={1} rowGap={1}>
      <Grid item xs={12} md={6}>
        {leftNode}
      </Grid>
      <Grid item xs={12} md={6}>
        {rightNode}
      </Grid>
    </Grid>
  )
}

export default Header
